import * as toastr from 'toastr';
import { OBTER_TRANSPORTADORAS } from '../actions/index';

export default function (state = {}, action) {
    switch (action.type) {
        case OBTER_TRANSPORTADORAS:                
            if(action.error){
                toastr.error("Erro obtendo transportadoras.");
                return state;                
            }else{           
                return action.payload;
            }
        default:
            return state;
    }   
}
